import axios from 'axios';

// Base URL for the external OTP microservice, as specified in the PDF: https://otp.indraq.info
const otpApi = axios.create({
  baseURL: 'https://otp.nefazo.com/',
});

// NOTE: This utility will handle direct communication with your microservice.
// It does NOT include the JWT token from the main application.

export default otpApi;